import React, { useContext, useEffect} from 'react'; 
import cl from './List.module.css'
import { AppContext } from "../../../../providers/appProvider"
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import Pagination from '../../../UI/Pagination/Pagination'; 
import Item from '../Item/Item'; 
import Delete from '../Delete/Delete';  
import { useTask } from '../../../../hooks/useTask';
import CalendarIcon from "../../../../assets/Icon/Calendar";  
import User from "../../../../assets/Icon/User";  
import Pen from "../../../../assets/Icon/Edit";  
import Time from "../../../../assets/Icon/Time";  
import Check from "../../../../assets/Icon/Check"; 
import { useTranslation } from 'react-i18next';
 
const TaskList = () => {
  const {t} = useTranslation();
  const { taskService } = useTask(50);
  const {appState, app} = useContext(AppContext);

  useEffect( ()=> {
     taskService.fetchList()
  }, [])

 

  const formatDate = (dateString) => {

 

    if (!dateString) {  
      return t("WithoutDeadline");
    } 

    const atDate = new Date(dateString);
    if (isNaN(atDate.getTime())) {
      return t("WithoutDeadline");
    } 
    if (dateString === "0001-01-01T00:00:00Z") {
      return t("WithoutDeadline");
  }

  
    atDate.setHours(atDate.getHours() - 4);
  
    const months = [
        t("Jan"),
        t("Feb"),
        t("Mar"),
        t("Apr"),
        t("May"),
        t("Jun"),
        t("Jul"),
        t("Aug"),
        t("Sep"),
        t("Oct"),
        t("Nov"),
        t("Dec")
    ]; 
    const day = atDate.getDate();
    const month = months[atDate.getMonth()]; 
    const year = atDate.getFullYear();
    const hours = atDate.getHours().toString().padStart(2, '0');
    const minutes = atDate.getMinutes().toString().padStart(2, '0');
     
    return `${day} ${month} ${year} `;
  };

 
  return <div>

    <div className={ cl.headMain }> 
        <h1>{t('Tasks')}</h1>  
        
        
        {app.hasPermission("TASK_ADD") &&
          <Item taskService={taskService} /> 
        } 
        
    </div>

    <div className={ cl.container }>
      <div className={ cl.row }>

              {taskService.items.map((item) =>
                <div className={ cl.col }>  
                    <div className={`${cl.taskBox} ${item.status === 1 ? cl.statusDone : ''}`}>

                      <div className={ cl.taskTitle }> 
                            <h1> {item.title} #{item.id}  </h1> 
                            <div className={ cl.btns }>
                              <Item taskService={taskService} defaultTask={item} modalType={'update'} author={item.auth?.firstname + " " + item.auth?.lastname}/>

                              {app.hasPermission("TASK_DELETE") && 
                                <Delete taskService={taskService} defaultTask={item}/> 
                              } 
                            </div>

                      </div> 


                      <div className={ cl.taskBody }>  
                           
                          <div style={{ display: 'flex', gap: '6px 6px', marginTop: '12px', flexWrap: 'wrap' }}>  
                            <span className={ cl.badge }><span className={cl.icon} ><Pen/></span> {item.auth?.firstname + " " + item.auth?.lastname} </span> 
                            <span className={ cl.badge }><span className={cl.icon} ><User/></span> {item.user?.firstname + " " + item.user?.lastname} </span> 
                          </div> 

                          <div style={{ display: 'flex', gap: '6px 6px', marginTop: '5px', flexWrap: 'wrap' }}> 

                            {item.priority === 1 &&  <span className={cl.badge}><span style={{ backgroundColor: '#d80228' }} className={cl.cricle}></span> {t('High')}</span>} 
                            {item.priority === 2 &&  <span className={cl.badge}><span style={{ backgroundColor: '#f1c40f' }} className={cl.cricle}></span> {t('Medium')}</span>} 
                            {item.priority === 3 &&  <span className={cl.badge}><span style={{ backgroundColor: '#1254e7' }} className={cl.cricle}></span> {t('Low')}</span>} 
                            <span className={ cl.badge }>  <span className={cl.icon} ><CalendarIcon/></span> {formatDate(item.deadline_at)}</span> 

                            {item.status === 0 &&  <span className={cl.badge}>
                              <span className={cl.icon }><Time/></span>{t('ToDo')}</span>} 
                          
                            {item.status === 1 &&  <span className={cl.badge}>
                              <span className={cl.icon + ' ' + cl.done} ><Check/></span>{t('Done')}</span>} 
                           
                          </div> 
  
                      </div>

                      
                      <div className={ cl.taskContent }>{item.content.replace(/<[^>]*>/g, '')}</div>  
                     
                    </div>
                </div>

              )} 

      </div>
    </div>
 

  
   {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}

    <Pagination total={taskService.total} 
                perPage={taskService.filter.limit} 
                current={taskService.filter.page} 
                paginate={(page) => {
                    taskService.setFilter({
                    ...taskService.filter,
                    page: page,
                  });
                }}
                setLimit={(limit) => {
                    taskService.setFilter({
                    ...taskService.filter,
                    limit: limit,
                  });
                }}
                />
  </div>;
}

export default TaskList;